export default "__VITE_ASSET__B6zOK2Bh__"